import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { NumberField } from 'src/Libs/inputs/react-hook-form'

export const BatteryNumber: React.FC<{ storageIndex: number }> = ({ storageIndex }) => {
  const { t } = useCustomTranslation()
  const { control } = useInstallationForm()
  const batteryNumber = useWatch({
    control,
    name: `storageSystem.storageSpecificSettings.${storageIndex}.advancedSettings.batteryNumber`,
  })

  return (
    <SettingsBox
      title={t('installation.storageEditor.count-modules')}
      suffix={
        <NumberField
          name={`storageSystem.storageSpecificSettings.${storageIndex}.advancedSettings.batteryNumber`}
          label={t('installation.storageEditor.count-modules')}
          value={batteryNumber ?? ''}
          disabled
        />
      }
    />
  )
}
